// extracted by mini-css-extract-plugin
export default {"SearchResult":"SearchResult_SearchResult__ZYAnn","Link":"SearchResult_Link__es4pD","DiscountPrice":"SearchResult_DiscountPrice__dn4gV","Price":"SearchResult_Price__FWkC1"};